/**
 * @generated SignedSource<<e2b170a0459a81675d5b3e4e0ad96fe3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingFragment$data = {
  readonly data: string | null | undefined;
  readonly id: string | null | undefined;
  readonly is_locked: boolean | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "SettingFragment";
};
export type SettingFragment$key = {
  readonly " $data"?: SettingFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_locked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "data",
      "storageKey": null
    }
  ],
  "type": "Setting",
  "abstractKey": null
};

(node as any).hash = "e67448c7ae8d01a7115e4b5bbc87e27e";

export default node;
